import { loadStripe } from "@stripe/stripe-js";
import { VITE_STRIPE_PUBLISHABLE_KEY } from "./config";

export const stripePromise = loadStripe(
  VITE_STRIPE_PUBLISHABLE_KEY
);
